export const setDatasets = datasets => {
	return { type: 'SET_DATASETS', datasets };
};

export const setDatasetInfo = (
	currentDataset,
	wbsData,
	projectActivities,
	projectActivitiesMap,
	projectActivityCodesRelativesMap,
	projectActivityCodesTree,
	projectActivityCodesTreeSequence,
	projectLayouts,
	projectLayoutId,
	projectViewType,
	projectGroupBy,
	projectGroupByActivityCode,
	projectMapGroupBy
) => {
	return {
		type: 'SET_DATASET_INFO',
		payload: {
			currentDataset,
			wbsData,
			projectActivities,
			projectActivitiesMap,
			projectActivityCodesRelativesMap,
			projectActivityCodesTree,
			projectActivityCodesTreeSequence,
			projectLayouts,
			projectLayoutId,
			projectViewType,
			projectGroupBy,
			projectGroupByActivityCode,
			projectMapGroupBy
		}
	};
};

export const setProjectActivities = projectActivities => {
	return { type: 'SET_PROJECT_ACTIVITIES', projectActivities };
};

export const setProjectViewType = projectViewType => {
	return { type: 'SET_PROJECT_VIEW_TYPE', projectViewType };
};

export const setProjectGroupBy = projectGroupBy => {
	return { type: 'SET_PROJECT_GROUP_BY', projectGroupBy };
};

export const setProjectGroupByActivityCode = projectGroupByActivityCode => {
	return { type: 'SET_PROJECT_GROUP_BY_ACTIVITY_CODE', projectGroupByActivityCode };
};

export const setProjectMapGroupBy = projectMapGroupBy => {
	return { type: 'SET_PROJECT_MAP_GROUP_BY', projectMapGroupBy };
};

export const setShowAddProjectModal = showAddProjectModal => {
	return {
		type: 'SET_SHOW_ADD_PROJECT_MODAL',
		payload: { showAddProjectModal }
	};
};
